



























































































































































import { BasicSelect } from 'vue-search-select';
import { User } from '@/store/admin/types';
import { Component, PropSync, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AuthUserRoles, canUserManageRole } from '@/auth/roles';
import CustomerDialogSelectOrganization from '@/components/Admin/Customers/CustomerDialogSelectOrganization.vue';
import { OrganizationData } from '@/store/organizations/types';
import { uuid } from 'vue-uuid';
import { SelectManagedUsersData, SelectProjectData } from '@/store/users/types';
import { UserPermission } from '@/store/userpermissions/types';
import { CustomerData } from '@/store/customers/types';
import { REDZONE_ORGANIZATION_GUID } from '@/common/Constants';
import hasRedzoneEmail from '@/common/utils/UserUtils';
import AdminPanelMixin, { UserTableData } from '../AdminPanelMixin.vue';
import PermissionsMatrix from './PermissionsMatrix.vue';
import CustomerEditDialog from '../Customers/CustomerEditDialog.vue';
import SelectProjects from './SelectProjects.vue';
import SelectManagedUsers from './SelectManagedUsers.vue';
import CustomerDialogMultiSelectCustomer from '../Customers/CustomerDialogMultiSelectCustomer.vue';

const adminModule = namespace('admin');

@Component({
  components: {
    BasicSelect,
    CustomerDialogSelectOrganization,
    PermissionsMatrix,
    CustomerEditDialog,
    SelectProjects,
    SelectManagedUsers,
    CustomerDialogMultiSelectCustomer,
  },
})
export default class CreateUser extends AdminPanelMixin {
  @adminModule.State('loadError') postUserError;

  @adminModule.State('loading') loadingPostUsers;

  @adminModule.State('response') userpostResponse;

  @PropSync('userData') synchedUserData: Array<UserTableData>;

  projects: Array<{ value: number; text: string; guid: string }> = [];

  snack = false;

  snackBarMessage = '';

  snackColor = 'black';

  startDateModel = false;

  endDateModel = false;

  newUserStep = 1;

  // Variables for form for user
  firstName = '' as string;

  lastName = '' as string;

  fieldName = '' as string;

  email = '' as string;

  userOrganization = {} as OrganizationData;

  userCustomers = [] as CustomerData[];

  newUserRole = '';

  lastProjectGuid = null as string;

  nasscoId = '' as string;

  // Variables for form for user roles

  userRoleGuid = null as string;

  roleGuid = '';

  managerGuid = null as string;

  startDate = null as string;

  endDate = null as string;

  selectedProject = { value: 0, text: '', guid: '' } as {
    value: number;
    text: string;
    guid: string;
  };

  newUserSelectedProjects = [] as SelectProjectData[];

  newUserSelectedManagedUsers = [] as SelectManagedUsersData[];

  valid = false as boolean;

  addUserDialog = false as boolean;

  allProjectsRoles = ['Reporting Technician', 'Reporting Manager'];

  get customerOptions(): { name: string, guid: string }[] {
    if (!this.customerDataList) {
      return [];
    }
    return this.customerDataList
      .filter((c) => c.organizationGuid === this.userOrganization.guid)
      .map((cust) => ({ name: cust.name, guid: cust.guid }));
  }

  get isFirstNewUserStep(): boolean {
    return this.newUserStep === 1;
  }

  get isLastNewUserStep(): boolean {
    return this.newUserStep === 3;
  }

  get roleItems(): string[] {
    const roles = hasRedzoneEmail(this.email)
      ? AuthUserRoles
      : AuthUserRoles.filter((role) => !role.redzoneOnly);
    const retVal = roles
      .map((r) => r.name)
      .filter((role) => canUserManageRole(this.$auth.user.role, role));

    if (!retVal.includes(this.newUserRole) && this.emailValid) {
      [this.newUserRole] = retVal;
    }

    return retVal;
  }

  /**
   * @returns true if the user has the permission ADMIN_CUSTOMER_SECTION_CREATEACUSTOMER
   */
  get hasPermissionAdminCreateACustomer(): boolean {
    return this.hasPermission(UserPermission.ADMIN_CUSTOMER_SECTION_CREATEACUSTOMER);
  }

  @Watch('userpostResponse')
  userPostResponseChange(): void {
    if (this.userpostResponse == null) {
      return;
    }
    this.snackBarMessage = this.userpostResponse.data;
    this.snackColor = 'green';
    this.snack = true;
  }

  @Watch('postUserError')
  userPostErrorChange(): void {
    if (this.postUserError == null) {
      return;
    }
    this.snackBarMessage = 'An error occured posting that User';
    this.snackColor = '#e61e25';
    this.snack = true;
  }

  @Watch('userOrganization')
  onUserOrganizationChange(): void {
    this.userCustomers = [] as CustomerData[];
  }

  @Watch('emailValid')
  onEmailValidChange(): void {
    if (!this.emailValid) {
      this.newUserRole = '';
    }
  }

  async mounted(): Promise<void> {
    this.fetchAllProjectsData()
      .catch(() => {
        this.$router.push({
          name: 'Error',
          params: {
            catchAll: 'Error',
            message: 'There was an error retrieving your projects. Please try again later. If this issue persists, please contact support.',
          },
        });
      });
  }

  async submit(): Promise<void> {
    let user = this.createUser();
    const organizationUser = {
      organizationGuid: this.userOrganization.guid,
      userGuid: user.Guid,
    };

    try {
      user = await this.$auth.createUser(user);

      // create new user
      await this.postUserData(user);

      // create new organization-user relationship
      await this.postOrganizationUser(organizationUser);

      // create new customer-user relationships
      await Promise.all(
        this.userCustomers.map(async (customer) => {
          const customerUser = {
            customerGuid: customer.guid,
            userGuid: user.Guid,
          };

          await this.postCustomerUser(customerUser);
        }),
      );

      // create new user management relationships for each common customer
      const userManagements = [];
      this.newUserSelectedManagedUsers.forEach(async (managedUser) => {
        this.userCustomerGuids.filter(
          (cust) => managedUser.customers?.includes(cust),
        ).forEach((customer) => {
          const userManagement = {
            managerUserGuid: user.Guid,
            subjectUserGuid: managedUser.userGuid,
            organizationGuid: this.userOrganization.guid,
            customerGuid: customer,
          };
          userManagements.push(this.postUserManagement(userManagement));
        });
      });
      await Promise.all(userManagements);
    } catch (ex) {
      this.snackBarMessage = (ex as Error).message;
      this.snackColor = '#e61e25';
      this.snack = true;
      return;
    }
    await this.$auth.sendPasswordReset(this.email);
    await this.resetForm();
    await this.updateAllManagedUsers();

    this.addUserDialog = false;
    this.$emit('onAddUser');
  }

  closeDialog(): void {
    this.addUserDialog = false;
    this.resetForm();
  }

  async nextStep(): Promise<void> {
    const canManage = await this.getCanManage(this.newUserRole);
    if (canManage?.length === 0) {
      this.newUserStep += 1;
    }
    this.newUserStep += 1;
  }

  async backStep(): Promise<void> {
    const canManage = await this.getCanManage(this.newUserRole);
    if (canManage?.length === 0) {
      this.newUserStep -= 1;
    }
    this.newUserStep -= 1;
  }

  async resetForm(): Promise<void> {
    this.roleGuid = '';
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.fieldName = '';
    this.email = '';
    this.userOrganization = {} as OrganizationData;
    this.userCustomers = [] as CustomerData[];
    this.newUserStep = 1;
    this.lastProjectGuid = '';
    this.newUserRole = '';
    this.nasscoId = '';
    this.userRoleGuid = '';
    this.managerGuid = '';
    this.startDate = '';
    this.endDate = '';
    this.newUserSelectedProjects = [];
    this.newUserSelectedManagedUsers = [];
    await (this.$refs.userCreateForm as HTMLFormElement).resetValidation();
  }

  createUser(): User {
    const currentUser = this.allUsers.find((u) => u.useridentity === `auth0|${this.$auth.user.id}`);
    const user = {} as User;

    user.Guid = uuid.v4();
    user.Nickname = this.email;
    user.Firstname = this.firstName;
    user.Lastname = this.lastName;
    user.Fieldname = this.fieldName;
    user.Email = this.email;
    user.LastProjectGuid = this.lastProjectGuid;
    user.Nasscoid = this.nasscoId;
    user.Role = AuthUserRoles.find((r) => r.name === this.newUserRole).guid;
    user.ManagerUserGuid = currentUser == null ? '' : currentUser.guid;
    user.Projects = this.newUserSelectedProjects.map((p) => p.projectGuid);

    return user;
  }

  onAddUser(): void {
    if (this.synchedUserData.length > 0) {
      this.synchedUserData = [];
    }
    this.fetchInactiveDetailedUserData();
    this.fetchAllDetailedUserData().then(this.$emit('updateAllUsers'));
  }

  /**
   * @returns true if the user has the permission ADMIN_ORGANIZATION_SECTION_CREATEANORGANIZATION
   */
  get hasPermissionAdminCreateAnOrganization(): boolean {
    return this.hasPermission(UserPermission.ADMIN_ORGANIZATION_SECTION_CREATEANORGANIZATION);
  }

  get userCustomerGuids(): string[] {
    return this.userCustomers.map((cust) => cust.guid);
  }

  get validPage(): boolean {
    switch (this.newUserStep) {
      case 1:
        return this.valid;
      case 2:
      case 3:
        return true;
      default:
        return false;
    }
  }

  /**
   * @returns true if the user's email ends in redzone.com
   */
  get isRedzone(): boolean {
    return hasRedzoneEmail(this.email);
  }

  @Watch('isRedzone')
  setRedZoneOrg(): void {
    if (this.isRedzone) {
      const redzoneOrg: OrganizationData = this.organizationDataList.find(
        (o) => o.guid === REDZONE_ORGANIZATION_GUID,
      );
      this.userOrganization = redzoneOrg;
    }
  }

  get emailValid(): boolean {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
  }

  isPrivilegedUser(): boolean {
    return hasRedzoneEmail(this.email) && this.allProjectsRoles.includes(this.newUserRole);
  }
}

